module.exports = __webpack_public_path__ + "static/media/18c-02_barro.7d8994bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18c/18c-02_barro.jpg
// module id = 229
// module chunks = 0